import { render, staticRenderFns } from "./asignarLibros.vue?vue&type=template&id=1883e388"
import script from "./asignarLibros.vue?vue&type=script&lang=js"
export * from "./asignarLibros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports